export const squareMetersToStremmata = (squareMeters) => {
  return squareMeters === 0 ? 0 : (squareMeters / 1000).toFixed(2);
};
export const squareMetersToAcre = (squareMeters) => {
  return squareMeters === 0 ? 0 : (squareMeters / 4046.856).toFixed(2);
};
export const squareMetersToHectares = (squareMeters) => {
  return squareMeters === 0 ? 0 : (squareMeters / 10000).toFixed(2);
};
export const hectaresToSquareMeters = (hectares) => {
  return hectares * 10000;
};
export const hectaresToStremmata = (hectares) => {
  return (hectares * 10).toFixed(2);
};
export const hectaresToAcre = (hectares) => {
  return (hectares * 2.47105).toFixed(2);
};

/**
 *
 * @param {*} t
 * @param {boolean} isEn
 * @param {number} dimensions
 * @param {Object} options
 * @param {'squareMeters' | 'hectares'} options.from
 * @param {'stremmata' | 'hectares'} options.to
 * @returns {string}
 */
export const fieldDimensionsRead = (
  t,
  isEn,
  dimensions,
  { from = "squareMeters", to = "stremmata" } = {
    from: "squareMeters",
    to: "stremmata",
  }
) => {
  if (isEn) {
    if (from === "squareMeters") {
      if (to === "stremmata") {
        return t("Global.FieldDimension.Acre", {
          dimension: squareMetersToAcre(dimensions),
        });
      }
      return t("Global.FieldDimension.Hectares", {
        dimension: squareMetersToHectares(dimensions),
      });
    }
    return t("Global.FieldDimension.Acre", {
      dimension: hectaresToAcre(dimensions),
    });
  }
  if (from === "squareMeters") {
    if (to === "stremmata") {
      return t("Global.FieldDimension.Stremmata", {
        dimension: squareMetersToStremmata(dimensions),
      });
    }
    return t("Global.FieldDimension.Hectares", {
      dimension: squareMetersToHectares(dimensions),
    });
  }
  return t("Global.FieldDimension.Stremmata", {
    dimension: hectaresToStremmata(dimensions),
  });
};

/**
 *
 * @param {*} t
 * @param {*} isEn
 * @param {*} dimensions
 * @param {'hectares' | 'stremmata'} unit
 * @returns
 */
export const includeUnitsToDimensions = (t, isEn, dimensions, unit) => {
  if (isEn) {
    if (unit === "hectares") {
      return t("Global.FieldDimension.Hectares", { dimension: dimensions });
    }
    return t("Global.FieldDimension.Acre", { dimension: dimensions });
  }
  if (unit === "hectares") {
    return t("Global.FieldDimension.Hectares", { dimension: dimensions });
  }
  return t("Global.FieldDimension.Stremmata", { dimension: dimensions });
};

/**
 *
 * @param {boolean} isEn
 * @param {number} dimensions
 * @param {Object} options
 * @param {'squareMeters' | 'hectares'} options.from
 * @param {'stremmata' | 'hectares'} options.to
 * @returns {number}
 */
export const fieldDimensionsNumber = (
  isEn,
  dimensions,
  { from = "squareMeters", to = "stremmata" } = {
    from: "squareMeters",
    to: "stremmata",
  }
) => {
  if (isEn) {
    if (from === "squareMeters") {
      if (to === "stremmata") {
        return squareMetersToAcre(dimensions);
      }
      return squareMetersToHectares(dimensions);
    }
    return hectaresToAcre(dimensions);
  }
  if (from === "squareMeters") {
    if (to === "stremmata") {
      return squareMetersToStremmata(dimensions);
    }
    return squareMetersToHectares(dimensions);
  }
  return hectaresToStremmata(dimensions);
};
